import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaDisciplinaNome = (): TabelaColuna => ({
  Chave: 'nomeDisciplina',
  RenderizarCabecalho: () => <div style={{ width: 150 }}>Nome Disciplina</div>
})
